import { ApiClientService, EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class UserApiService extends EntityApiService {
  updateStatus = (params) => {
    return ApiClientService.post(this.getPath('/status'), params);
  }
  passwordReset = (params) => {
    return ApiClientService.post(this.getPath('/password-reset'), params);
  }

  getOnePublic = (id, config) => {
    return ApiClientService.get(this.getPath(`/${id}/public`, null), config);
  }

  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }

  exportExcel = async (params) => {
    return ApiClientService.post(this.getPath('/export?format=excel'), params, { responseType: 'blob' });
  }

  verify = async (idNumber, params) => {
    return ApiClientService.get(this.getPath(`/${idNumber}/verify`), params);
  }

  getUserProposals = async (id, config) => {
    return ApiClientService.get(this.getPath(`/${id}/proposals`), config);
  }
}

export default new UserApiService(`${authentication.path}/api/users`);
